import React, { useState } from 'react'
import ReactTable from 'react-table'
import { Link } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import {
  Row, Col, Divider, DatePicker, Badge, Modal,
} from 'antd'
import _ from 'lodash'
import {
  Div, Button, Icon, Input, H3, DynamicButtonLink, Loading, P,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/tire-inventory-components'
import {
  TIRE_INVENTORYLOG, TIRE_INVENTORY,
} from '../../../constants/graph/query'
import { ListContainer, Select } from '../../../components/common'
import { PAYMENT_TYPE } from '../constants'
import '../list/style-css.css'
import PERMISSION from '../../../constants/permissions'
import contentForHistory from './contentForHistory'

const { color } = theme

const Index = ({ data }) => (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>ประวัติสินค้าของ {data.productName}</H3>
    </Div>
    <List id={data.inventoryOptions[0].id} />
  </Div>
)

export const List = ({ id }) => {
  const [current, setCurrent] = useState(0)
  const [variable, setVariable] = useState({})
  const {
    data, loading, error, fetchMore, refetch,
  } = useQuery(TIRE_INVENTORYLOG, {
    variables: {
      ...variable,
      limit: 5,
      offset: 5 * current,
      orderField: 'updatedAt',
      orderBy: 'DESC',
      inventoryOptionId: id,
    },
  })
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      {loading && _.isEmpty(data) && <Loading center='true' />}
      {(!loading || !_.isEmpty(data))
        && <Div>
          <ReactTable
            className='table'
            data={data.TransferTireSerialList.lists} // *
            resizable={false}
            columns={contentForHistory.columns} // *
            minRows={5}
            manual
            // defaultPageSize={10}
            showPageSizeOptions={false}
            getTdProps={() => ({ disabled: true })} // *
            getTrProps={(state, rowInfo) => { // *
              if (rowInfo) {
                return {
                  style: {
                    padding: '8px 0',
                    backgroundColor: '#ffffff',
                    borderLeft: `3px solid ${color.primaryColor}`,
                  },
                }
              } return {}
            }}
            previousText='ก่อนหน้า'
            nextText='ถัดไป'
            pageText='หน้า'
            ofText='จาก'
            page={current}
            pages={Math.ceil(data.TransferTireSerialList.totalFilter / 5)}
            onPageChange={(page) => {
              setCurrent(page)
              refetch({ offset: 5 * current })
            }}
            onFilteredChange={async (newFiltered) => {
              const newOjb = {
                sku: '',
                productName: '',
                brand: '',
                supplierName: '',
                category: '',
                productGroup: 'ALL',
              }
              await newFiltered.forEach((v) => {
                if (v.id === 'PreviousSerialWarehouse.warehouseName') {
                  Object.assign(newOjb, { oldwarehouseId: v.value })
                } else if (v.id === 'CurrentSerialWarehouse.warehouseName') {
                  Object.assign(newOjb, { warehouseId: v.value })
                } else {
                  Object.assign(newOjb, { [v.id]: v.value })
                }
              })
              setCurrent(0)
              setVariable(newOjb)
              refetch(newOjb)
            }}
            onSortedChange={async (newSorted) => {
              setCurrent(0)
              refetch({
                orderBy: newSorted[0].desc ? 'DESC' : 'ASC',
                orderField: newSorted[0].id,
              })
            }}
            SubComponent={(props) => {
              const serials = _.map(props.original.TransferedSerials, v => v.serialNumber)
              return (
              <Div display='flex' flexDirection='column' margin='0 0 0 3px' padding='20px 40px 20px' style={{ backgroundColor: '#fff', borderRadius: '0 0 32px 32px' }}>
                <Row>
                  <P margin='0 8px 0 0' bold>serial ที่ย้าย:</P>
                  <P>{_.join(serials, ', ')}</P>
                </Row>
              </Div>
              )
            }}
          />
          {
            loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
          }
        </Div>
      }
    </Wrapper>
  )
}

export default ({ props }) => {
  const { loading: infoLoading, data: infoData, error: infoError } = useQuery(TIRE_INVENTORY, { variables: { id: props.match.params.id } })
  if (infoLoading && _.isUndefined(infoData)) return <Loading center='true' />
  const data = infoData.TireInfo
  return (
    <Index data={data} />
  )
}
